import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { IHoliday } from '../types';
import { StyledHolidayImage } from './styles';
import { HolidayRowActions } from './holiday-row-actions';
import { useAuthRolePermissions } from '@app/utils';

interface Props {
  holiday: IHoliday;
}

const HolidayCard = ({ holiday }: Props) => {
  const date = dayjs(holiday.date);
  const { hasPermission } = useAuthRolePermissions();
  const canEditHoliday = hasPermission('Holiday', 'w');

  return (
    <Stack direction="row" alignItems="center">
      <StyledHolidayImage image={holiday.image}>
        <Stack direction={'row'} justifyContent={'space-between'} width={'90%'}>
          <Typography variant="h6" color="primary.contrastText" alignSelf={'end'}>
            {holiday.name}
          </Typography>
          <Stack alignItems="center" color="primary.contrastText">
            <Typography variant="h5">{date.format('DD')}</Typography>
            <Typography variant="subtitle2" color="primary.contrastText" textTransform="uppercase">
              {date.format('ddd')}
            </Typography>
          </Stack>
        </Stack>
      </StyledHolidayImage>
      <Stack>{canEditHoliday && <HolidayRowActions row={holiday} />}</Stack>
    </Stack>
  );
};

export { HolidayCard };
